import React, { FC } from 'react';
import { Icon, IconButton, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { RiskEntity } from '../../../api/types/RiskEntities';
import { useAppDrawer } from '../../../../../components/AppDrawer/AppDrawerProvider';
import InvestigationDrawer from '../../../../../components/InvestigationDrawer/InvestigationDrawer';

const getIconByEntityType = (entityType?: number) => {
    switch (entityType) {
        case AD_ENTITY_TYPES.SERVER:
            return Icons.Server;
        case AD_ENTITY_TYPES.USER:
            return Icons.User;
        default:
            return Icons.User;
    }
};

const IdentifierColumn: FC<Partial<RiskEntity>> = ({ name, type, guid }) => {
    const entityIcon = getIconByEntityType(type);
    const { displayContent } = useAppDrawer();

    const onInvestigateClicked = () => {
        displayContent(<InvestigationDrawer guid={guid} identifier={name} adType={type || AD_ENTITY_TYPES.USER} />);
    };

    return name && type ? (
        <div className="h-full w-full flex flex-1 items-center gap-2">
            <Icon icon={entityIcon} size={20} className="flex-none text-sf-gray-400" />
            <Tooltip title={name} onlyOnOverflow>
                <span className="w-[248px] truncate text-13 text-gray-800 font-sf">{name}</span>
            </Tooltip>
            <IconButton
                icon={Icons.Investigate}
                iconSize={20}
                className="invisible group-hover:visible"
                buttonStyle={IconButtonStyles.Secondary}
                onClick={onInvestigateClicked}
            />
        </div>
    ) : null;
};

export default IdentifierColumn;
